<template>
  <q-dialog class="dialog promote-dialog">
    <q-card class="promote-dialog__inner">
      <common-form :action="$route('project.promote', { project_id: projectId })">
        <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
          <div class="heading-3 q-mr-sm">Afronden {{ phase.title }}</div>
          <q-space />
          <icon-button icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup />
        </q-card-section>
        <q-card-section class="dialog__messages" :class="$isMobile ? 'q-pb-none' : 'q-px-lg q-pt-none q-pb-sm'">
          Weet u zeker dat u deze fase wilt afronden?
        </q-card-section>
        <q-card-section class="dialog__form" :class="{'q-px-lg': $isDesktop}">
          <common-input name="reason" v-model="form.reason"
                        label="Opmerking"
                        type="textarea"
                        :error-message="$errorMessage('reason')"
                        :error="$hasError('reason')"
                        autofocus
          />
        </q-card-section>
        <template v-if="openRules > 0">
          <q-separator />
          <q-card-section class="dialog__form" :class="{'q-px-lg': $isDesktop}">
            <div class="heading-3 q-mr-sm">Er zijn nog {{ openRules }} openstaande richtlijnen</div>
            <expansion-element :label="category.title" v-for="category in openCategories" :key="category.id"
                               :items-count="openRuleVersions[category.id].length"
                               :id="`open-category-${category.id}`">
              <q-list bordered separator class="rounded-borders">
                <q-item v-for="ruleVersion in openRuleVersions[category.id]"
                        :key="ruleVersion.id"
                        class="items-center">
                  <q-item-section>
                    <div class="row items-center q-col-gutter-md">
                      <div class="col-xs-9">
                        {{ ruleVersion.rule.code }} - {{ ruleVersion.summary }}
                      </div>
                      <status-value
                          class="col-xs-3"
                          :status="$ruleStatusColor(ruleVersion.pivot.status)"
                          :label="$ruleStatusLabel(ruleVersion.pivot.status)"
                          :hide-label="!$isDesktop"
                      />
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </expansion-element>
          </q-card-section>
        </template>
        <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
          <accent-button
              label="Promoveren"
              type="submit"
          />
          <flat-button
              label="Annuleren"
              v-close-popup
          />
        </q-card-actions>
      </common-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { STATUS_APPROVED } from '~HIOR/constants/ruleStatus'
import { ruleMixin } from '~HIOR/mixins'

export default {
  mixins: [ruleMixin],
  props: {
    ruleVersions: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    projectId: {
      type: Number,
      required: true,
    },
    phase: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      form: {
        reason: '',
      },
    }
  },
  computed: {
    openRuleVersions () {
      return this.categories.reduce((ruleVersions, category) => {
        ruleVersions[category.id] = this.ruleVersions[category.id].filter(rule => {
          return rule.pivot?.status !== STATUS_APPROVED
        })
        return ruleVersions
      }, {})
    },
    openCategories () {
      return this.categories.filter(category => {
        return this.openRuleVersions[category.id] && this.openRuleVersions[category.id].length
      })
    },
    hasOpenRules () {
      return this.openRules > 0
    },
    openRules () {
      return this.openCategories.reduce((sum, category) => {
        return sum + this.openRuleVersions[category.id].length
      }, 0)
    },
  },
}
</script>
